import React from "react";

// Full-page spinner shown while auth is verified and while a route chunk loads.
// `inline` fills the admin content area instead of the whole viewport.
const PageLoader = ({ inline = false }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: inline ? "60vh" : "100vh",
      background: inline ? "transparent" : "#fff",
      color: "#6c757d",
      fontFamily: "Arial, sans-serif",
    }}
  >
    <div
      className="spinner-border text-primary mb-3"
      role="status"
      style={{ width: "2.5rem", height: "2.5rem" }}
    >
      <span className="visually-hidden">Loading...</span>
    </div>
    <div style={{ fontSize: "1.1rem", fontWeight: 400 }}>Loading...</div>
  </div>
);

export default PageLoader;
